import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { HttpClient } from "@angular/common/http";
import { TranslateService } from "@ngx-translate/core";
import { FormGroup } from "@angular/forms";

@Component({
  selector: "app-dialog-info",
  templateUrl: "./dialog-info.component.html",
  styleUrls: [
    "./dialog-info.component.scss"
  ]
})
export class DialogInfoComponent {

  obsForm!: FormGroup;

  constructor(
        private dialogRef: MatDialogRef<DialogInfoComponent>,
        // eslint-disable-next-line
        @Inject(MAT_DIALOG_DATA) public data: any,
        private translate: TranslateService,
        protected http: HttpClient) { }

  formatDate(date: string): string {
    return new Date(date).toLocaleDateString("it-IT", {
      day: "2-digit", month: "2-digit", year: "numeric",
      hour: "2-digit", minute: "2-digit"
    });
  }

  async buttonClicked(buttonType: string) {

    switch (buttonType) {
    case "ok": {
      this.dialogRef.close();
      break;
    }
    default: {
      this.dialogRef.close();
      break;
    }
    }
  }
}